export default {
	formObject: {},

	init: function() {
		this.formObject = document.getElementById('js-contact-form');
		if(this.formObject !== null) {
			this.bindSubmitEvent();

			$('.form-status--error').css('display', 'none');
			$('.form-status--success').css('display', 'none');
		}
	},

	bindSubmitEvent: function() {
		this.formObject.addEventListener("submit", this.handleSubmit.bind(this));
	},

	handleSubmit: function(event) {
		event.preventDefault();

		var self = this;

		//remove existing error/success classes
		$('.form-status--error').css('display', 'none');
		$('.form-status--success').css('display', 'none');
		$('.error').removeClass('error');

		var formData = new FormData(event.target);

		jQuery.ajax({
			url: langSegment + "xcontact",
			data: formData,
			type: 'POST',
			dataType: 'json',
			contentType: false,
			processData: false,
			success: function (resData) {

				if (resData['status']) {
					$('.form-status--success').css('display', 'block');

					//scroll to success display
					$('html, body').animate({
						scrollTop: $('.xtop').offset().top - 140
					}, 500);

					document.getElementById("js-contact-form").reset();
					self.formObject.reset();
					

					$('.error').removeClass('error');

				} else {
					if (resData.errorType == 'validation') {
						//add error classes
						for (var field in resData.form_error) {
							if (resData.form_error[field]) {
								if (field == 'msg') {
									$('textarea[name=' + field + ']').parent().addClass('error');
								}
								else {
									$('input[name=' + field + ']').parent().addClass('error');
								}
							}
						}

						// $('.form-status--error').html("Validation error, please fill required fields.");
					} else {
						$('.form-status--error').html("Server error, please try again later.");
					}

					$('.form-status--error').css('display', 'block');

					//scroll to error display
					$('html, body').animate({
						scrollTop: $('.xtop').offset().top - 140
					}, 500);
				}
			},
			catch: function(error) {
				$('.form-status--error').html("Server error, please try again later.");
				$('.form-status--error').css('display', 'block');
			}
		});
	}
};
